
import {
  Inject,
  Injectable,
  DOCUMENT,
} from "@angular/core";
import {
    CashierTypes,
    PaymentHistoryStatuses,
    WsPaymentUpdateModel,
} from "@Front-end/seed/models/payment";
import { UserBonus } from "@Front-end/seed/models/user";
import {
    loadUserSuccess,
    logoutUser,
    pingFailure,
    sendMessage,
    showBonuses,
    updatePayment,
} from "@Front-end/seed/modules/user";
import { ResponseError } from "@Front-end/seed/utils/interfaces";
import { ModalOpenType } from "@Front-end/ui/models/modal";
import { QueueNotificationService } from "@Front-end/ui/modules/notifications";

import {
    Actions,
    createEffect,
    ofType,
} from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { debounceTime } from "rxjs";
import { tap } from "rxjs/operators";
import {
    errorPrefix,
    errorTitle,
} from "../constants/common.constants";
import { StorageKeys } from "../constants/storage.constants";
import { AppPopupsService } from "./services/app-popups.service";

@Injectable()
export class AppUserEffects {
    constructor(
        private actions$: Actions,
        private queueNotificationService: QueueNotificationService,
        private appPopupsService: AppPopupsService,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    public pingFailure$ = createEffect(() => this.actions$.pipe(
        ofType(pingFailure),
        tap((error: ResponseError) =>
            this.queueNotificationService.addNotification({
                label: this.translateService.instant(errorTitle),
                message: this.translateService.instant(errorPrefix + error.code),
            }),
        ),
    ), { dispatch: false });

    public saveWasLoggedIn$ = createEffect(() => this.actions$.pipe(
        ofType(loadUserSuccess),
        tap(() => {
            if (this.document?.defaultView?.localStorage) {
                this.document.defaultView.localStorage.setItem(StorageKeys.lsWasLoggedIn, "yes");
            }
        }),
    ), { dispatch: false });

    public checkUserAvatar$ = createEffect(() => this.actions$.pipe(
        ofType(loadUserSuccess),
        tap(({ avatar }) => {
            if (!avatar) {
                this.appPopupsService.fireChooseAvatar(ModalOpenType.PROGRAM);
            }
        }),
    ), { dispatch: false });

    public openRegistrationPopup$ = createEffect(() => this.actions$.pipe(
        ofType(showBonuses),
        debounceTime(500),
        tap(({ bonuses }: { bonuses: UserBonus[] }) => {
            this.appPopupsService.fireOpenRegistrationBonus(bonuses, ModalOpenType.PROGRAM);
        }),
    ), { dispatch: false });


    // disable customer.io in app massage when user wal log out
    public resetCustomerIoOnLoggedOut = createEffect(() => this.actions$.pipe(
        ofType(logoutUser),
        tap(() => {
            // @ts-expect-error
            this.document.defaultView?.analytics?.reset();
            // @ts-expect-error
            this.document.defaultView?.cioanalytics?.reset();
        }),
    ), { dispatch: false });

    // handle payment status update
    public handlePaymentUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(updatePayment),
        tap(({ data }: { data: WsPaymentUpdateModel }) => {
            // @ts-ignore
            if (this.document.defaultView.LiveChatWidget
                && data.status === PaymentHistoryStatuses.DECLINE
                && data.type === CashierTypes.DEPOSIT) {
                // @ts-ignore
                // this.document.defaultView.LiveChatWidget.call("maximize", { messageDraft: this.translateService.instant("common.jivo-proactive") });
            }
        }),
    ), { dispatch: false });

    // handle socket message
    public handleSocketMessage$ = createEffect(() => this.actions$.pipe(
        ofType(sendMessage),
        tap(({ message }) => {
            this.queueNotificationService.addNotification({
                label: this.translateService.instant(message.title),
                // @ts-ignore
                message: this.translateService.instant(message.message, { amount: message.vars.amount }),
            });
        }),
    ), { dispatch: false });
}
